<template>
    <div 
        :style="componentStyles"
        class="o-avia-schedule"
    >
        <OAviaScheduleTable
            :header-cells="departuresHeaderCells"
            :data="departuresData"
            :label="$t('ui.schedule.departure')"
        />
        <OAviaScheduleTable
            :header-cells="arrivalHeaderCells"
            :data="arrivalsData"
            :label="$t('ui.schedule.arrival')"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import OAviaScheduleTable from '../../unique-organisms/o-avia-schedule-table';

import {
    ARRIVAL_HEADER_CELL,
    DEPARTURE_HEADER_CELL
} from "./constants";

export default {
    name: 'OAviaSchedule',
    components: {
        OAviaScheduleTable
    },
    props: {
        schedule: {
            type: Array,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        departuresHeaderCells() {
            return DEPARTURE_HEADER_CELL.map(el => this.$t(el));
        },
        arrivalHeaderCells() {
            return ARRIVAL_HEADER_CELL.map(el => this.$t(el));
        },
        departuresData() {
            const data = this.schedule.filter(el => el.arr_dep === 'D');
            return this.prepareData(data);
        },
        arrivalsData() {
            const data = this.schedule.filter(el => el.arr_dep === 'A');
            return this.prepareData(data);
        },
        componentStyles() {
            return this.getMapConfigProp('components.OAviaScheduleTable.styles') || null;
        }
    },
    methods: {
        formatNearestTime(time){
            const t = this.$moment(time);
            return (t > this.$moment().add(1,'hour') || t < this.$moment()) ? t.format('H:mm')
                : Math.round( this.$moment.duration( t.diff(this.$moment()) ).asMinutes() ) + ' min';
        },
        prepareData(arr) {
            return arr.map(item => {
                const id = item['@attributes'].uniqueID;
                const statusCode = _.get(item,'status[@attributes].code');
                const region = this.$t(`ui.schedule.avinor.region_${item.dom_int}`);
                const status = statusCode
                    ? this.$t(`ui.schedule.avinor.status_${statusCode}`) : '';
                const statusTime = _.get(item,'status[@attributes].time');
                const time = statusTime ? this.formatNearestTime(statusTime) : '';
                const delayed = item.delayed ?? '';

                return {
                    ...item,
                    id,
                    nearestTime: this.formatNearestTime(item.schedule_time),
                    region,
                    status,
                    time,
                    delayed
                }
            });
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
